import React, { useState, useRef, useEffect } from "react";

//Import Mui
import {
  Box,
  Button,
  CardContent,
  Divider,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
} from "@mui/material";
import MuiTextField from "../../controls/MuiTextField";
import MuiTableSearch from "../../controls/MuiTableSearch";
import MuiAutoComplete from "../../controls/MuiAutoComplete";
import Alert from "../../controls/MuiSnackbarAlert";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";

//Import AntD
import { Modal } from "antd";

//Import Redux
import { useDispatch, useSelector } from "react-redux";

//Import Reduxtoolkit
import { unwrapResult } from "@reduxjs/toolkit";

//Import from loginSlice.js
import {
  getSignInUser,
  getSignInUserFromServer,
} from "../../registration/signin/loginSlice";

//Import from uomSlice.js
import { getUoMFromServer, selectAllUoM } from "../uom/uomSlice";

//Import from itemSlice.js
import {
  addItemToServer,
  deleteItemFromServer,
  getItemsCountFromServer,
  getItemsFromServer,
  getItemsFromServerByPagination,
  updateItemInServer,
} from "./itemSlice";

//Import CSS
import "./item.css";

const Item = () => {
  const { confirm } = Modal;
  const dispatch = useDispatch();
  const uomList = useSelector(selectAllUoM);
  const signInUser = useSelector(getSignInUser);

  //useState
  const [loginUser, setLoginUser] = useState(signInUser);
  const [showFieldsContainer, setShowFieldsContainer] = useState(false);
  const [itemId, setItemId] = useState(0);
  const [itemCode, setItemCode] = useState("");
  const [itemName, setItemName] = useState("");
  const [uomCode, setUoMCode] = useState("");
  const [uomName, setUoMName] = useState("");
  const [uom, setUoM] = useState([]);
  const [selectedUoM, setSelectedUoM] = useState(null);
  const [unitPrice, setUnitPrice] = useState("");
  const [buttonSave, setButtonSave] = useState("Save");
  const [itemsList, setItemsList] = useState([]);
  const [originalItemsList, setOriginalItemsList] = useState([]); // I have used this hook for handling Table Data search.
  const [itemsCount, setItemsCount] = useState(0);
  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    severity: "",
  });
  // const [preventTableDataRendering, setPreventTableDataRendering] =
  //   useState(true);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  //End useState

  //useRef
  const itemCodeRef = useRef(null);
  const itemNameRef = useRef(null);
  const uomRef = useRef(null);
  const unitPriceRef = useRef(null);
  const saveRef = useState(null);
  const cancelRef = useState(null);
  const clearRef = useState(null);
  //End useRef

  const fetchDatasByPagination = async (pageNo, rowSize) => {
    try {
      const result = await dispatch(
        getItemsFromServerByPagination({ pageNo, rowSize })
      );
      const unwrappedResult = unwrapResult(result);
      if (unwrappedResult.data.length === 0) {
        setNotify({
          isOpen: true,
          message: unwrappedResult.message,
          severity: "warning",
        });
        return;
      }
      if (Array.isArray(unwrappedResult.data))
        setItemsList(unwrappedResult.data);
    } catch (err) {
      console.log({ ErrorOccured: err });
      setNotify({
        isOpen: true,
        message: err.message,
        severity: "error",
      });
    }
  };

  // useEffect
  useEffect(() => {
    if (loginUser === null) {
      dispatch(getSignInUserFromServer())
        .then(unwrapResult)
        .then((result) => setLoginUser(result.data));
    }
    const fetchDatas = async () => {
      try {
        // if (uomList.length > 0) {
        //   setUoM(uomList);
        // } else {
          const uoMListsresult = await dispatch(getUoMFromServer());
          const unwrappedUoMResult = unwrapResult(uoMListsresult);
          setUoM(unwrappedUoMResult.data);
        // }

        const itemsListResult = await dispatch(getItemsFromServer());
        const unwrappedItemsResult = unwrapResult(itemsListResult);
        if (unwrappedItemsResult.data.length > 0) {
          setOriginalItemsList(unwrappedItemsResult.data);
        }

        const itemCountResult = await dispatch(getItemsCountFromServer());
        const unwrappedItemCountResult = unwrapResult(itemCountResult);
        unwrappedItemCountResult.data[0].ItemsCount === undefined
          ? setItemsCount(0)
          : setItemsCount(unwrappedItemCountResult.data[0].ItemsCount);
      } catch (err) {
        console.log({ ErrorOccured: err });
        setNotify({
          isOpen: true,
          message: err.message,
          severity: "error",
        });
      }
    };
    setTimeout(() => {
      fetchDatas();
    }, 1000);
  }, []);
  // End useEffect

  useEffect(() => {
    fetchDatasByPagination(page + 1, rowsPerPage);
  }, [page, rowsPerPage]);

  const handleAdd = (e) => {
    e.preventDefault();
    setShowFieldsContainer(true);
    resetfields();
  };

  const handleRefresh = () => {
    window.location.reload();
  };

  const handleUoMChange = (e, value) => {
    e.preventDefault();
    setSelectedUoM(value);
    if (value) {
      setUoMCode(value.UCode);
      setUoMName(value.UName);
    }
    unitPriceRef.current.focus();
  };

  const handleCancel = (e) => {
    e.preventDefault();
    resetfields();
    setShowFieldsContainer(false);
    setButtonSave("Save");
  };

  const handleClear = (e) => {
    e.preventDefault();
    resetfields();
    itemCodeRef.current.focus();
  };

  const resetfields = () => {
    setItemId(0);
    setItemCode("");
    setItemName("");
    setSelectedUoM(null);
    setUnitPrice("");
  };

  const columns = [
    { id: "Action", label: "Action", minWidth: 100 },
    {
      id: "Id",
      label: "Id",
      minWidth: 170,
    },
    { id: "ICode", label: "Code", minWidth: 170 },
    { id: "IName", label: "Name", minWidth: 170 },
    { id: "UName", label: "UoM", minWidth: 170 },
    { id: "UnitPrice", label: "Unit Price", align: "right", minWidth: 170 },
  ];

  const handleSave = (e) => {
    e.preventDefault();
    validate();
  };

  const validate = async () => {
    let trimmedItemCode = itemCode.trim();
    let trimmedItemName = itemName.trim();
    if (trimmedItemCode === "") {
      setNotify({
        isOpen: true,
        message: "Item Code is required",
        severity: "warning",
      });
      itemCodeRef.current.focus();
      return;
    } else if (trimmedItemName === "") {
      setNotify({
        isOpen: true,
        message: "Item Name is required",
        severity: "warning",
      });
      itemNameRef.current.focus();
      return;
    } else if (selectedUoM === null) {
      setNotify({
        isOpen: true,
        message: "UoM is required",
        severity: "warning",
      });
      uomRef.current.focus();
      return;
    } else if (unitPrice === "") {
      setNotify({
        isOpen: true,
        message: "Unit Price is required",
        severity: "warning",
      });
      unitPriceRef.current.focus();
      return;
    } else {
      if (buttonSave === "Save") {
        let newItem = {
          itemCode: trimmedItemCode,
          itemName: trimmedItemName,
          uomCode,
          uomName,
          unitPrice: parseFloat(unitPrice).toFixed(2),
          loginUser,
        };
        await dispatch(addItemToServer(newItem))
          .then(unwrapResult)
          .then((result) => {
            if (result.flag === 1) {
              setNotify({
                isOpen: true,
                message: result.message,
                severity: "success",
              });
            } else if (result.flag === 2) {
              setNotify({
                isOpen: true,
                message: result.message,
                severity: "warning",
              });
            } else {
              setNotify({
                isOpen: true,
                message: result.message,
                severity: "error",
              });
            }
          })
          .catch((err) => {
            console.log({ ErrorOccured: err });
            setNotify({
              isOpen: true,
              message: err.message,
              severity: "error",
            });
          });

        await dispatch(getItemsCountFromServer())
          .then(unwrapResult)
          .then((result) => {
            setItemsCount(result.data[0].ItemsCount);
          })
          .catch((err) => {
            console.log({ ErrorOccured: err });
            setNotify({
              isOpen: true,
              message: err.message,
              severity: "error",
            });
          });
      } else {
        let updatedItem = {
          itemCode: trimmedItemCode,
          itemName: trimmedItemName,
          uomCode,
          uomName,
          unitPrice,
          loginUser,
        };
        await dispatch(updateItemInServer({ ...updatedItem, itemId }))
          .then(unwrapResult)
          .then((result) => {
            if (result.flag === 1) {
              setNotify({
                isOpen: true,
                message: result.message,
                severity: "success",
              });
            } else if (result.flag === 2) {
              setNotify({
                isOpen: true,
                message: result.message,
                severity: "warning",
              });
            } else {
              setNotify({
                isOpen: true,
                message: result.message,
                severity: "error",
              });
            }
          })
          .catch((err) => {
            console.log({ ErrorOccured: err });
            setNotify({
              isOpen: true,
              message: err.message,
              severity: "error",
            });
          });
      }
      await fetchDatasByPagination(page + 1, rowsPerPage);
      resetfields();
      itemCodeRef.current.focus();
      setButtonSave("Save");
      return;
    }
  };

  const handleEdit = (item) => {
    const selectiveUoM = uom.find((record) => record.UName === item.UName);
    showFieldsContainer
      ? itemCodeRef.current.focus()
      : setShowFieldsContainer(true);
    setItemId(item.Id);
    setItemCode(item.ICode);
    setItemName(item.IName);
    setSelectedUoM(selectiveUoM);
    setUoMCode(selectiveUoM.UCode);
    setUoMName(selectiveUoM.UName);
    setUnitPrice(item.UnitPrice);
    setButtonSave("Update");
  };

  const handleUpdate = () => {
    validate();
  };

  const handleDelete = async (itemid) => {
    resetfields();
    setButtonSave("Save");
    confirm({
      title: "Are you sure to delete this item?",
      // content: "Some descriptions",
      okText: "Yes",
      okType: "danger",
      cancelText: "No",
      async onOk() {
        await dispatch(deleteItemFromServer({ itemid, loginUser }))
          .then(unwrapResult)
          .then((result) => {
            if (result.flag === 1) {
              setNotify({
                isOpen: true,
                message: result.message,
                severity: "success",
              });
            } else {
              setNotify({
                isOpen: true,
                message: result.message,
                severity: "error",
              });
            }
          })
          .catch((err) => {
            console.log({ ErrorOccured: err });
            setNotify({
              isOpen: true,
              message: err.message,
              severity: "error",
            });
          });

        await dispatch(getItemsCountFromServer())
          .then(unwrapResult)
          .then((result) => {
            setItemsCount(result.data[0].ItemsCount);
          })
          .catch((err) => {
            console.log({ ErrorOccured: err });
            setNotify({
              isOpen: true,
              message: err.message,
              severity: "error",
            });
          });

        // console.log(page);
        let currentPage = parseInt(page + 1);
        // console.log(currentPage);
        // console.log(rowsPerPage);
        // console.log(originalItemsList.length);
        // console.log(itemsCount);
        const newTotalRecords = itemsCount - 1;
        // console.log(newTotalRecords);
        const totalPages = Math.ceil(newTotalRecords / rowsPerPage); // rowcount
        // console.log(totalPages);
        if (currentPage > totalPages) {
          setPage(Math.max(totalPages - 1, 0)); // Ensures the page is at least 0
          await fetchDatasByPagination(page, rowsPerPage);
        } else {
          await fetchDatasByPagination(page + 1, rowsPerPage);
        }
        showFieldsContainer
          ? itemCodeRef.current.focus()
          : setShowFieldsContainer(false);
      },
      onCancel() {
        console.log("Cancel");
      },
    });
  };

  const handleChangePage = (event, newPage) => {
    event.preventDefault();
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(event.target.value);
    setPage(0);
  };

  const handleSearch = (searchedVal) => {
    if (!searchedVal) {
      fetchDatasByPagination(page + 1, rowsPerPage);
    } else {
      const filteredRows = originalItemsList.filter((item) => {
        return (
          item.ICode.toLowerCase().includes(searchedVal.toLowerCase()) ||
          item.IName.toLowerCase().includes(searchedVal.toLowerCase())
        );
      });
      setItemsList(filteredRows);
    }
  };

  return (
    <>
      <Box className="itemboxcontainer">
        <Alert notify={notify} setNotify={setNotify} />
        <Grid
          container
          alignItems="center"
          justifyContent="space-between"
          sx={{ mb: "5px" }}
        >
          <Grid item>
            <Button
              variant="outlined"
              size="small"
              onClick={handleAdd}
              sx={{ mb: "5px" }}
            >
              Add
            </Button>
            <Button
              variant="outlined"
              size="small"
              onClick={handleRefresh}
              sx={{ mb: "5px", ml: "10px" }}
            >
              Refresh
            </Button>
          </Grid>
          <Grid
            item
            sx={{ display: "flex", alignItems: "center", mt: "-13px" }}
          >
            <MuiTableSearch
              placeholder="Search Item"
              onChange={(e) => handleSearch(e.target.value)}
            />
          </Grid>
        </Grid>

        {showFieldsContainer ? (
          <Paper className="paper" elevation={2} sx={{ p: 2 }}>
            <h6>Add Item</h6>
            <Divider />
            <CardContent>
              <Grid container spacing={2} className="gridContainer">
                <Grid item xs={12} sm={6} md={3}>
                  <MuiTextField
                    id="itemcode"
                    label="Item Code *"
                    onChange={(e) => {
                      setItemCode(e.target.value);
                    }}
                    value={itemCode}
                    inputRef={itemCodeRef}
                    autoComplete="off"
                    autoFocus
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <MuiTextField
                    id="itemname"
                    label="Item Name *"
                    onChange={(e) => {
                      setItemName(e.target.value);
                    }}
                    value={itemName}
                    inputRef={itemNameRef}
                    autoComplete="off"
                    onKeyDown={(e) => {
                      if (e.key.toLowerCase() === "home")
                        itemCodeRef.current.focus();
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <MuiAutoComplete
                    id="uom"
                    clearOnEscape
                    autoHighlight
                    autoSelect
                    options={uom}
                    getOptionLabel={(option) => {
                      if (typeof option === "object" && option !== null) {
                        return option.UName;
                      }
                      return selectedUoM.UName ?? "";
                    }}
                    value={selectedUoM}
                    onChange={handleUoMChange}
                    renderInput={(params) => (
                      <MuiTextField
                        {...params}
                        label="UoM *"
                        inputRef={uomRef}
                        onKeyDown={(e) => {
                          if (e.key.toLowerCase() === "home")
                            itemNameRef.current.focus();
                        }}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <MuiTextField
                    type="number"
                    id="unitprice"
                    label="Unit Price *"
                    onChange={(e) => {
                      //not allow to enter negative values - /^\d*\.?\d*$/
                      //not allow to enter negative values & allow only 2 digits after decimal - /^\d*\.?\d{0,2}$/
                      const newValue = e.target.value;
                      if (!newValue || newValue.match(/^\d*\.?\d{0,2}$/)) {
                        setUnitPrice(parseFloat(newValue));
                      }
                    }}
                    value={isNaN(unitPrice) ? "" : unitPrice}
                    inputRef={unitPriceRef}
                    autoComplete="off"
                    onKeyDown={(e) => {
                      if (e.key.toLowerCase() === "home")
                        uomRef.current.focus();
                    }}
                  />
                </Grid>

                <Grid item xs={12}></Grid>
                <Grid item xs={12} sm={6} md={12} className="itemButtons">
                  <div className="buttonGroup">
                    {buttonSave === "Save" ? (
                      <Button
                        variant="contained"
                        size="small"
                        className="btnsave"
                        ref={saveRef}
                        onKeyDown={(e) => {
                          if (e.key.toLowerCase() === "home")
                            unitPriceRef.current.focus();
                        }}
                        onClick={handleSave}
                      >
                        Save
                      </Button>
                    ) : (
                      <Button
                        variant="contained"
                        size="small"
                        className="btnupdate"
                        ref={saveRef}
                        onKeyDown={(e) => {
                          if (e.key.toLowerCase() === "home")
                            unitPriceRef.current.focus();
                        }}
                        onClick={handleUpdate}
                      >
                        Update
                      </Button>
                    )}
                    <Button
                      className="btncancel"
                      variant="contained"
                      size="small"
                      ref={cancelRef}
                      onKeyDown={(e) => {
                        if (e.key.toLowerCase() === "home")
                          saveRef.current.focus();
                      }}
                      onClick={handleCancel}
                    >
                      Cancel
                    </Button>
                    <Button
                      variant="contained"
                      size="small"
                      className="btnclear"
                      ref={clearRef}
                      onKeyDown={(e) => {
                        if (e.key.toLowerCase() === "home")
                          cancelRef.current.focus();
                      }}
                      onClick={handleClear}
                    >
                      Clear
                    </Button>
                  </div>
                </Grid>
              </Grid>
            </CardContent>
          </Paper>
        ) : (
          ""
        )}
      </Box>
      <Box
        className="itemboxcontainer"
        sx={showFieldsContainer ? { mt: 3 } : { mt: 0 }}
      >
        <Paper elevation={2} sx={{ p: 2 }}>
          <TableContainer sx={{ maxHeight: 1000 }}>
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow>
                  {columns.map((column) => (
                    <TableCell
                      key={column.id}
                      align={column.align}
                      style={{ minWidth: column.minWidth }}
                      hidden={column.id === "Id" ? true : false}
                    >
                      {column.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {itemsList.length > 0 ? (
                  itemsList.map((item) => (
                    <TableRow key={item.Id}>
                      <TableCell>
                        <EditIcon
                          className="editicon"
                          fontSize="medium"
                          onClick={() => handleEdit(item)}
                        />
                        <DeleteIcon
                          className="deleteicon"
                          fontSize="medium"
                          onClick={() => handleDelete(item.Id)}
                        />
                      </TableCell>
                      <TableCell hidden={true}>{item.Id}</TableCell>
                      <TableCell>{item.ICode}</TableCell>
                      <TableCell>{item.IName}</TableCell>
                      <TableCell>{item.UName}</TableCell>
                      <TableCell align="right">{item.UnitPrice}</TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={columns.length} align="center">
                      No Items found
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>

          <TablePagination
            className="MuiTablePagination-selectLabel"
            rowsPerPageOptions={[10, 25, 50, 75, 100]}
            component="div"
            count={itemsCount}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Paper>
      </Box>
    </>
  );
};

export default Item;
